import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

function InfoBox({ title, description, type }) {
  return (
    <>
      {title} &nbsp;
      {type === 'purchase' && (
        <OverlayTrigger
          placement={'top'}
          overlay={<Tooltip id={`tooltip-${title}`}>{description}</Tooltip>}
        >
          <span>
            <i className="feather icon-info"></i>
          </span>
        </OverlayTrigger>
      )}
    </>
  );
}

export default InfoBox;
